/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
export const UpdateSuggestionRequest = core.serialization.object({
    suggestion: core.serialization.any(),
});
